import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { Icon, usePageMeta, PageHero, FinalCTA } from "../components/Shared";
import { INDUSTRIES, IMAGES } from "../data/site";

export default function Industries() {
  usePageMeta("Industries", "CoreDock Logistics serves freight carriers, brokers and 3PLs, manufacturers, distributors, retail and e-commerce businesses, and importers and exporters across the GTA.");
  return (
    <>
      <PageHero eyebrow="Industries Served" image={IMAGES.containers}
        title="Built for the People Who Move Freight"
        subtitle="Whatever your role in the supply chain, CoreDock provides responsive handling and flexible logistics across the GTA and Ontario." />

      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-20 md:py-28">
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-border border border-border">
          {INDUSTRIES.map((ind) => (
            <StaggerItem key={ind.title} data-testid={`industry-${ind.title.toLowerCase().replace(/[^a-z]+/g,'-')}`}
                         className="group bg-white p-10 hover:bg-navy transition-colors duration-300">
              <div className="w-12 h-12 flex items-center justify-center bg-navy text-orange group-hover:bg-orange group-hover:text-white transition-colors">
                <Icon name={ind.icon} size={24} strokeWidth={1.5} />
              </div>
              <h3 className="font-display font-bold text-xl mt-6 group-hover:text-white transition-colors">{ind.title}</h3>
              <p className="mt-3 text-sm text-text-secondary leading-relaxed group-hover:text-white/60 transition-colors">{ind.desc}</p>
            </StaggerItem>
          ))}
        </Stagger>

        <Reveal className="mt-16 bg-offwhite border-l-4 border-orange p-8 md:p-10">
          <p className="text-lg text-text-secondary leading-relaxed max-w-3xl">
            Don't see your industry listed? If you move commercial freight through the Greater Toronto Area,
            we can likely help. Reach out and tell us what you're moving.
          </p>
        </Reveal>
      </div>
      <FinalCTA />
    </>
  );
}
